
import { RatingModel } from '../models/rating/rating.model';
import { StylingModel } from '../models/style/styling.model';
import { RatingStylingModel } from '../models/rating/rating-styling.model';

export const /** @type {?} */ RatingTemplates = {
  defaultTemplate: {
    property: new RatingModel({
      display: true,
      disable: false,
      label: 'Rating label',
      icon: 'star',
      value: 1,
      max: 5,
      countFromEnd: false,
      iconsVertical: false
    }),
    style : new RatingStylingModel({
      iconSize: '30px',
      filledColor: 'lightseagreen',
      emptyColor: 'darkseagreen',
    })
  }
}
